import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { useLoaderDelay } from '@wix/da-ds/pkg/LoadingIndicator/useLoaderDelay';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
import InfoIcon from '@wix/da-ds/pkg/Icons/16x16/Info';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './LoadingPostfix.scss';

interface Props {}

/**
 * An info icon with a tooltip that indicates that we're still loading the estimated earnings. Will start
 * a slow opacity animation if loading takes too long.
 */
const LoadingPostfix: React.FC<Props> = () => {
  const { t } = useTranslation();
  const showLoadingAnimation = useLoaderDelay();

  return (
    <SimpleTooltip text={t('estimatedEarnings.loading.tooltip')}>
      <InfoIcon
        aria-label={t('estimatedEarnings.loading.tooltip')}
        size={IconSize.SMALLER}
        className={c(showLoadingAnimation && s['loading-icon'])}
        disableDefaultColors
      />
    </SimpleTooltip>
  );
};

LoadingPostfix.displayName = 'LoadingPostfix';

export default LoadingPostfix;
